import http from '@/api/http'

import { TGetProfilesResponse } from './types'

export const getProfiles = async () => {
  const response = await http.get<TGetProfilesResponse>('/users/profile/')
  return response.data
}
